import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { deleteStripeCards, getStripeCards, selectedCardFunc, setOpenAddCardModal, setPaymentMethodSelection, updateStripePayableAmountAction } from "../../actions/stripe";
import { SUPPORTED_PAYMENT_METHOD } from "../../constants";
import DeleteCard from "./DeleteCard";

export default function SelectPayment({ forwardPaymentPage }) {
  const { stripeCards, selectedCard, openCartPage } = useSelector(state => state.stripe);
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false);
  const [cardId, setCardId] = useState(null);
  const [isDeleteCard, setIsDeleteCard] = useState(false);
  const addNewCardunc = () => {
    dispatch(setOpenAddCardModal(true));
  };

  useEffect(() => {
    dispatch(getStripeCards());
  }, [dispatch]);

  const selectPaymentMethod = (item, isForward) => {
    dispatch(updateStripePayableAmountAction(0));
    dispatch(setPaymentMethodSelection(item));
    if (isForward) {
      forwardPaymentPage(item);
    }
  };

  useEffect(() => {
    if (openCartPage && selectedCard) {
      selectPaymentMethod(SUPPORTED_PAYMENT_METHOD.PAY_WITH_CARD, true)
    }
  }, [openCartPage, selectedCard])

  const selectCard = item => {
    dispatch(selectedCardFunc(item));
    selectPaymentMethod(SUPPORTED_PAYMENT_METHOD.PAY_WITH_CARD, false);
  };

  const handleDelete = async () => {
    if (cardId) {
      setLoader(true)
      await dispatch(deleteStripeCards(cardId));
      setLoader(false)
      setIsDeleteCard(false)
      setCardId(null)
    }
  };

  const renderDeleteActions = (item) => {
    setIsDeleteCard(true);
    setCardId(item.id);
  };

  const logoImage = (item) => {
    switch (item?.card?.brand) {
      case 'visa':
        return 'visa';
      case 'jcb':
        return 'jcb';
      case 'mastercard':
        return 'mastercard';
      case 'unionpay':
        return 'unionpay';
      case 'amex':
        return 'americanex';
      case 'dinersCard':
        return 'diner';
      default:
        return 'australia';
    }
  };
  return (
    <>
      <div className="container">
        <DeleteCard
          isOpen={isDeleteCard}
          onHide={() => setIsDeleteCard(false)}
          deleteCardFunc={handleDelete}
          loader={loader}
        />
        <div className="row buyProductSectionBg">
          <div className="col-md-12">
            <p className="m-0 selectPaymentTitle">
              Select your preferred payment
            </p>

            <div className="cardBackgroundSection">
              {stripeCards?.length > 0 &&
                stripeCards?.map((item, index) => (
                  <div key={index}>
                    <div
                      onClick={() => selectCard(item)} className={`${item?.id === selectedCard?.id ? "cardDetailsSectionActive" : ""} cardDetailsSection`}>
                      <div className="leftCardSection">
                        <div>
                          <img src={`assets/img/${logoImage(item)}.svg`} alt="" />
                        </div>
                        <div className="LeftCardDetails">
                          <h6 className="m-0">{item.billing_details?.name || '-'} | ....{' '}
                            {item?.card?.last4}</h6>
                          <p className="deleteIconText" onClick={() => renderDeleteActions(item)}>
                            <img src="assets/img/deleteCard.svg" alt="" srcset="" />{" "}Delete
                          </p>
                        </div>
                      </div>
                      <div>
                        <input type="radio" checked={item?.id === selectedCard?.id} className="radioButton" />
                      </div>
                    </div>
                    <hr className="hrLine m-0" />
                  </div>
                ))}
              <div onClick={addNewCardunc} className="cardDetailsSection">
                <div className="leftCardSection">
                  <div>
                    <img src="assets/img/addCard.svg" alt="" />
                  </div>
                  <div className="LeftCardDetails">
                    <h6 className="m-0">Add new card</h6>
                    <p className="m-0">Save and pay via cards</p>
                  </div>
                </div>
                <div></div>
              </div>
            </div>
            {/* onClick={() => selectPaymentMethod(SUPPORTED_PAYMENT_METHOD.BANK_TRANSFER, true)} */}
            <div className="cardBackgroundSection">
              <div className="cardDetailsSection">
                <div className="leftCardSection">
                  <div>
                    <img src="assets/img/bankIcon.svg" alt="" />
                  </div>
                  <div className="LeftCardDetails">
                    <h6 className="m-0">Bank transfer</h6>
                    <p className="m-0">Coming soon</p>
                  </div>
                </div>
                <div>
                  <svg
                    width="8"
                    height="14"
                    viewBox="0 0 8 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1 1L7 7L1 13"
                      stroke="#3B3B3B"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
              </div>
            </div>

            <div onClick={() => selectPaymentMethod(SUPPORTED_PAYMENT_METHOD.BANK_TRANSFER, true)} className="cardBackgroundSection">
              <div className="cardDetailsSection">
                <div className="leftCardSection">
                  <div>
                    <img src="assets/img/pay-now.png" alt="" className="selectPaymentIcon" />
                  </div>
                  <div className="LeftCardDetails">
                    <h6 className="m-0">Pay now</h6>
                  </div>
                </div>
                <div>
                  <svg
                    width="8"
                    height="14"
                    viewBox="0 0 8 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1 1L7 7L1 13"
                      stroke="#3B3B3B"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
              </div>
            </div>


            <div onClick={() => selectPaymentMethod(SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO, true)} className="cardBackgroundSection">
              <div className="cardDetailsSection">
                <div className="leftCardSection">
                  <div>
                    <img src="assets/img/cryptoIcon.svg" alt="" />
                  </div>
                  <div className="LeftCardDetails">
                    <h6 className="m-0">Crypto</h6>
                    <p className="m-0">
                      You can use favourite crypto for payment
                    </p>
                  </div>
                </div>
                <div>
                  <svg
                    width="8"
                    height="14"
                    viewBox="0 0 8 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1 1L7 7L1 13"
                      stroke="#3B3B3B"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
              </div>
            </div>

            {/* <div className="cardBackgroundSection m-0">
              <div className="cardDetailsSection">
                <div className="leftCardSection">
                  <div>
                    <img src="assets/img/paidUpCapital.svg" alt="" />
                  </div>
                  <div className="LeftCardDetails">
                    <h6 className="m-0">Paid-up Capital</h6>
                    <p className="m-0">You can pay with capital</p>
                  </div>
                </div>
                <div>
                  <svg
                    width="8"
                    height="14"
                    viewBox="0 0 8 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1 1L7 7L1 13"
                      stroke="#3B3B3B"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
}
